import { render, staticRenderFns } from "./NewslettersRoute.vue?vue&type=template&id=76f6c2a7&scoped=true&"
import script from "./NewslettersRoute.vue?vue&type=script&lang=js&"
export * from "./NewslettersRoute.vue?vue&type=script&lang=js&"
import style0 from "./NewslettersRoute.vue?vue&type=style&index=0&id=76f6c2a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f6c2a7",
  null
  
)

export default component.exports